export default "__VITE_ASSET__e2656d7a__"